import gql from "graphql-tag";
import { ProductInfoFragment } from "./fragments";

export const AddproductMutation = gql`
  mutation addProduct($input: ProductCreationInput!) {
    addProduct(input: $input) {
      statusCode
      message
      data {
        ...ProductInfo
      }
    }
  }
  ${ProductInfoFragment}
`;

export const deleteProductMutation = gql`
  mutation deleteProduct($input: ProductDeleteInput!) {
    deleteProduct(input: $input) {
      message
      statusCode
    }
  }
`;

export const updateProductMutation = gql`
  mutation updateProduct($input: ProductUpdateInput!) {
    updateProduct(input: $input) {
      statusCode
      message
      data {
        ...ProductInfo
      }
    }
  }
  ${ProductInfoFragment}
`;

export const uploadProductsMutation = gql`
  mutation uploadProducts($input: ProductsUploadInput!) {
    uploadProducts(input: $input) {
      statusCode
      message
      data {
        ...ProductInfo
      }
    }
  }
  ${ProductInfoFragment}
`;
